'use client';
// src/components/ui/TransitionDePage.tsx
// La transition d'une page à l'autre (19/10/2026, essai 3 des animations demandées par David).
//
// L'API View Transitions du navigateur, pilotée par React : la navigation de Next est une
// transition React, et `<ViewTransition>` demande au navigateur une photo de l'ancienne page
// et de la nouvelle, qu'il fond l'une dans l'autre. Aucune dépendance, rien sur le fil
// principal pendant l'animation. Le navigateur qui ne la connaît pas change de page sans
// effet, comme avant.
//
// Ce qui bouge : le contenu seul. L'ancienne page s'efface vite (`--dur-fast`), la nouvelle
// monte de 6 px en fondu (`--dur-base`). Le cadre (`root`) ne se fond pas — la barre du site ne
// clignote pas — et le conteneur ne s'étire pas d'une hauteur de page à l'autre (`group`
// sans animation). Rien pour qui demande moins de mouvement.
//
// Le composant est TOUJOURS rendu, même éteint (classe `none`) : l'ajouter ou le retirer quand
// la session arrive changerait l'arbre, et remonterait toute la page.
// Réservé, comme les trois colonnes, à la nouvelle présentation (admins).

import { ViewTransition, type ReactNode } from 'react';
import { useNouvellePresentation } from '@/hooks/useNouvellePresentation';

const STYLE_TRANSITION_PAGE = `
@keyframes page-sortie { to { opacity: 0; } }
@keyframes page-entree { from { opacity: 0; transform: translateY(6px); } }
::view-transition-old(root), ::view-transition-new(root) { animation: none; }
::view-transition-group(.page) { animation: none; }
::view-transition-old(.page) { animation: page-sortie var(--dur-fast, 120ms) var(--ease-std, ease) both; }
::view-transition-new(.page) { animation: page-entree var(--dur-base, 220ms) var(--ease-out, ease-out) both; }
@media (prefers-reduced-motion: reduce) {
  ::view-transition-old(.page), ::view-transition-new(.page) { animation: none; }
}
`;

export function TransitionDePage({ children }: { children: ReactNode }) {
  const actif = useNouvellePresentation();
  return (
    <>
      {actif && <style>{STYLE_TRANSITION_PAGE}</style>}
      <ViewTransition default={actif ? 'page' : 'none'}>
        <div className="app-shell">{children}</div>
      </ViewTransition>
    </>
  );
}
